// Central app configuration
// Extend this as needed (e.g., env, build time, feature flags)

export interface AppConfig {
  version: string;
}

export const APP_CONFIG: AppConfig = {
  version: "1.1.0",
};
